module.exports = "../fonts/additional_bed_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/additional_bed_icon.svg
// module id = 441
// module chunks = 0